type ClassValue = string | number | bigint | boolean | null | undefined | ClassValue[];

/**
 * Join class names, dropping falsy values.
 *
 * Deliberately not `tailwind-merge`: components in this app own their base
 * classes and take a `className` for layout only, so there is nothing to
 * de-duplicate and no runtime cost to pay for.
 */
export function cn(...values: ClassValue[]): string {
  const out: string[] = [];
  for (const value of values) {
    if (!value) continue;
    if (Array.isArray(value)) {
      const nested = cn(...value);
      if (nested) out.push(nested);
    } else {
      out.push(String(value));
    }
  }
  return out.join(" ");
}
